import { apiClient } from "@/services/HttpService";
export function fetchProjectProgress(projectId){
  return apiClient.get(`/project/${projectId}/progress`);
}

export function updateProjectEngineeringProgress(params) {
  return apiClient.post("/project/engineering-progress", params);
}

export function updateProjectPaymentProgress(params) {
  return apiClient.post("/project/payment-progress", params);
}

export function loadEngineerProgressLogs(projectId){
  return apiClient.get(`/project/${projectId}/engineer-progress-log`);
}

export function rollbackEngineerProgress(progressLogId, projectId) {
  return apiClient.post(`/project/engineering-progress/rollback?targetProgressLogId=${progressLogId}&projectId=${projectId}`);
}

export function loadPaymentProgressLogs(projectId){
  return apiClient.get(`/project/${projectId}/payment-progress-log`);
}

export function rollbackPaymentProgress(progressLogId, projectId) {
  return apiClient.post(`/project/payment-progress/rollback?targetProgressLogId=${progressLogId}&projectId=${projectId}`);
}

export function updateProgressDocs(params) {
  return apiClient.post("/project/progress-docs", params);
}